"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heart = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

function Heart(_a) {
  var children = _a.children,
      _b = _a.fill,
      fill = _b === void 0 ? 'currentColor' : _b,
      props = tslib_1.__rest(_a, ["children", "fill"]);

  return react_1.default.createElement("svg", tslib_1.__assign({
    width: "20",
    height: "18",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), children, react_1.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 2.54132C11.0649 1.37451 12.5566 0.688355 14.1354 0.63916C16.9266 0.63916 19.1894 2.90194 19.1894 5.69321C19.1894 8.99786 15.5158 12.6196 13.3126 14.7917C13.1142 14.9873 12.9278 15.1711 12.757 15.3419L10.6618 17.437C10.5327 17.5663 10.3575 17.639 10.1748 17.6392H9.82563C9.64291 17.639 9.46773 17.5663 9.3386 17.437L7.24347 15.3419C7.0727 15.1711 6.88625 14.9873 6.68789 14.7917C4.48464 12.6196 0.811035 8.99786 0.811035 5.69321C0.811035 2.90194 3.07381 0.63916 5.86509 0.63916C7.44388 0.688355 8.93553 1.37451 10.0002 2.54132ZM10.0005 15.4985L12.0222 13.5045C13.8876 11.6666 17.3519 8.22987 17.3519 5.69366C17.3519 4.83587 17.0093 4.0136 16.4002 3.40965C15.791 2.80569 14.9659 2.47009 14.1081 2.47744C12.6795 2.61006 11.3899 3.38857 10.607 4.59095C10.5193 4.70553 10.3837 4.77333 10.2395 4.77474H9.82595C9.61126 4.77416 9.40844 4.67613 9.2746 4.50825C8.50418 3.35018 7.25062 2.60345 5.86541 2.47744C4.08915 2.47744 2.6492 3.91739 2.6492 5.69366C2.6492 8.22987 6.11352 11.6666 7.97893 13.5045L10.0005 15.4985Z",
    fill: fill
  }));
}

exports.Heart = Heart;